import { Step } from '../intefaces/step';
import { Observable, of } from 'rxjs';

export class StepImpl implements Step {
  isActive = false;

  isHidden = false;

  protected ready = false;

  constructor(public text: string, public readonly name: string) {}

  isReady(): boolean {
    return this.ready;
  }

  setReady(): void {
    this.ready = true;
  }

  reset(): void {
    this.ready = false;
  }

  submit(): Observable<boolean> {
    return of(this.ready);
  }
}
